import React from "react";



const Precios = (props) => {

  const priceHandleOne = (minPrice, maxPrice, interval) => {
    const arrayPrices = [];
    for (let i = minPrice; i <= maxPrice; i = i + interval) {
      arrayPrices.push(i);
    }
    return priceHandleTwo(arrayPrices);
  }
  const priceHandleTwo = (arrayPrices) => {
    return (
      arrayPrices.map((item, index) =>
        <option key={index} value={item}>{`${item} €`}</option>
      )
    )
  }

  return (
    <>
      <option value='indiferente'>Indiferente</option>
      {
        props.fotoCasaForm.transaccion === 'traspaso'
          ?
          <>
            {priceHandleOne(15000, 300000, 15000)}
          </>
          :
          props.fotoCasaForm.transaccion === 'alquiler-opcion-compra'
            ?
            <>
              {priceHandleTwo([25, 50, 100])}
              {priceHandleOne(150, 2400, 150)}
              {priceHandleTwo([3000, 3600, 4200, 6000, 10000, 15000])}
            </>
            :
            props.fotoCasaForm.transaccion === 'compartir'
              ?
              <>
                <option value={25}>25 €</option>
                {priceHandleOne(50, 850, 50)}
                <option value={1000}>1000 €</option>
              </>
              :
              props.fotoCasaForm.transaccion === 'alquilar'
                ? props.fotoCasaForm.tipoInmueble === 'vivienda'
                  ?
                  <>
                    {priceHandleOne(100, 1000, 50)}
                    {priceHandleTwo([1100, 1200, 1250])}
                    {priceHandleOne(1300, 1700, 100)}
                    <option value={1750}>1750 €</option>
                    {priceHandleOne(1800, 2000, 100)}
                    {priceHandleOne(2250, 3000, 250)}
                    {priceHandleOne(3500, 4500, 500)}
                    <option value={6000}>6000 €</option>
                  </>
                  : props.fotoCasaForm.tipoInmueble === 'garaje'
                    ?
                    <>
                      {priceHandleOne(30, 300, 30)}
                    </>
                    : props.fotoCasaForm.tipoInmueble === 'trastero'
                      ?
                      <>
                        {priceHandleTwo([150, 180, 200, 250, 300, 500])}
                      </>
                      : props.fotoCasaForm.tipoInmueble === 'edificio'
                        ?
                        <>
                          {priceHandleTwo([250, 400])}
                          {priceHandleOne(600, 1500, 300)}
                          {priceHandleOne(2000, 3000, 1000)}
                          {priceHandleTwo([3600])}
                          {priceHandleOne(5000, 15000, 2500)}
                          {priceHandleTwo([20000, 30000, 50000])}
                        </>
                        :
                        <>
                          {priceHandleOne(300, 6000, 300)}
                        </>
                : props.fotoCasaForm.tipoInmueble === 'vivienda'
                  ?
                  <>
                    {priceHandleOne(50000, 500000, 25000)}
                    {priceHandleOne(600000, 1000000, 50000)}
                    {priceHandleOne(1100000, 2000000, 100000)}
                    {priceHandleOne(2250000, 3000000, 250000)}
                    {priceHandleTwo([3500000, 4000000])}
                  </>
                  : props.fotoCasaForm.tipoInmueble === 'garaje'
                    ?
                    <>
                      {priceHandleOne(5000, 50000, 5000)}
                    </>
                    : props.fotoCasaForm.tipoInmueble === 'trastero'
                      ?
                      <>
                        {priceHandleTwo([6000, 12000, 15000, 18000, 24000, 30000])}
                      </>
                      : props.fotoCasaForm.tipoInmueble === 'terreno'
                        ?
                        <>
                          {priceHandleOne(50000, 600000, 50000)}
                          {priceHandleTwo([1000000, 2000000, 2500000])}
                        </>
                        : props.fotoCasaForm.tipoInmueble === 'edificio'
                          ?
                          <>
                            {priceHandleOne(30000, 180000, 30000)}
                            {priceHandleTwo([240000, 300000, 450000])}
                            {priceHandleOne(600000, 1500000, 300000)}
                            {priceHandleTwo([2000000, 3500000, 5000000, 7000000, 10000000])}
                          </>
                          : props.fotoCasaForm.tipoInmueble === 'local-nave'
                            ?
                            <>
                              {priceHandleOne(50000, 600000, 50000)}
                              {priceHandleTwo([1200000, 1500000, 2000000])}
                            </>
                            :
                            <>
                              {priceHandleOne(50000, 600000, 50000)}
                              {priceHandleTwo([1000000, 1500000, 2000000])}
                            </>
      }
    </>)
}

export default Precios;